<div id="about">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Chairman's Message</h4>
                  <div class="card-body text-center">
                    <div class="row ">
                        <div class="col-12 text-center">
                            <img appLazyload src="/assets/img/message/3.jpeg" alt="Chairman Message" class="img-fluid rounded">
                        </div>
                    </div>
                     <p class="inner-lead">RPDAV School, Shahabad is the premier educational institution founded more than 30 years ago and is in forefront of providing quality education and character-building for students. In the last two years when all schools were affected by COVID, RPDAV school continued to provide very high-quality interactive online education to children through a team of dedicated teaching and supporting staff giving excellent academic results. Smartphones were also gifted to a few children so that nobody lags. The school has now restarted classroom education with all Covid precautions. The school also takes pride in organizing free COVID vaccination camps. The school remains committed to providing a very high standard of education, extracurricular activities, and sports thereby transforming children into first-class citizens of the country.</p>
                     <p class="inner-lead mb-0">Chairman</p>
                     <p class="inner-lead mb-0">Brig (Retd), R K Gupta</p>
                     <p class="inner-lead mb-0">VSM</p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>